import { Action, createReducer, on } from '@ngrx/store';
import { CartItem } from '../../interfaces/cart.interface';
import {
  AddCartItem,
  BatchAddCartItem,
  BatchUpdateCartItem,
  EmptyCart,
  RemoveCartItem,
  UpdateCartItem,
} from '../actions/cart.actions';

// Dieser ngrx-Reducer handhabt den Zustand des Einkaufswagens (cart) und ist für die Verarbeitung von Aktionen wie "AddCartItem",
// "RemoveCartItem", "UpdateCartItem" und "EmptyCart" zuständig.

let cartItems: CartItem[] = [];

if (localStorage.getItem('cartState')) {
  cartItems = JSON.parse(localStorage.getItem('cartState') || '[]');
}

const reducer = createReducer(
  cartItems,
  on(AddCartItem, (state, payload) => {
    const inCart = state.filter(
      (item) => item.product.sku.toString() === payload.product.sku.toString()
    );
    if (inCart.length > 0) {
      localStorage.setItem('cartState', JSON.stringify(state));
      return state;
    } else {
      const newCart = [...state, payload];
      localStorage.setItem('cartState', JSON.stringify(newCart));
      return newCart;
    }
  }),
  on(BatchAddCartItem, (state, payload) => {
    const inCart = state.filter((item) =>
      payload.items.some(
        (product) =>
          item.product.sku.toString() === product.product.sku.toString()
      )
    );
    if (inCart.length > 0) {
      localStorage.setItem('cartState', JSON.stringify(state));
      return state;
    } else {
      const stateCopy = [...state, ...payload.items];
      localStorage.setItem('cartState', JSON.stringify(stateCopy));
      return stateCopy;
    }
  }),
  on(RemoveCartItem, (state, payload) => {
    const newCart = [
      ...state.filter(
        (item) => item.product.sku.toString() !== payload.product.sku.toString()
      ),
    ];
    localStorage.setItem('cartState', JSON.stringify(newCart));
    return newCart;
  }),
  on(UpdateCartItem, (state, payload) => {
    const newCart = [
      ...state.map((item) =>
        item.product.sku.toString() === payload.item.product.sku.toString()
          ? payload.item
          : item
      ),
    ];
    localStorage.setItem('cartState', JSON.stringify(newCart));
    return newCart;
  }),
  on(BatchUpdateCartItem, (state, payload) => {
    const alreadyPresent = [];
    const newState = [];
    for (let i = 0; i < state.length; i++) {
      const item = state[i];
      const present = payload.items.find(
        (product) =>
          item.product.sku.toString() === product.product.sku.toString()
      );
      if (present) {
        alreadyPresent.push(present.productId);
        newState.push(item);
      }
    }

    for (let i = 0; i < payload.items.length; i++) {
      const item = payload.items[i];
      if (!alreadyPresent.find((x) => x === item.productId)) {
        newState.push(item);
      }
    }
    localStorage.setItem('cartState', JSON.stringify(newState));
    return newState;
  }),
  on(EmptyCart, () => {
    localStorage.setItem('cartState', JSON.stringify([]));
    return [];
  })
);

export const CartReducer = (state: any, action: Action) =>
  reducer(state, action);
